// This file was automatically generated and should not be edited.

// ====================================================
// Core Object Capability Type Identity
// ====================================================

/** @package */
export const GeneratedPlatformCapability = {
  COLLABORATABLE: 'COLLABORATABLE',
  CORE_OBJECT_ARCHIVABLE: 'CORE_OBJECT_ARCHIVABLE',
  DATA_CATALOG_ITEM: 'DATA_CATALOG_ITEM',
  HAS_CUSTOM_FIELDS: 'HAS_CUSTOM_FIELDS',
  HAS_PROVENANCE_URI: 'HAS_PROVENANCE_URI',
  HAS_SCHEMA: 'HAS_SCHEMA',
  PIPELINE: 'PIPELINE',
  PUBLISHABLE: 'PUBLISHABLE',
  STARRABLE: 'STARRABLE',
  STUDYABLE: 'STUDYABLE',
} as const;

/** @package */
export const GeneratedDomainGraphInterface = {
  ...GeneratedPlatformCapability,
  CAN_EDIT_WORKFLOW_SCHEMA_FIELD_VALUES: 'CAN_EDIT_WORKFLOW_SCHEMA_FIELD_VALUES',
  IMMUTABLE_DOMAIN_OBJECT: 'IMMUTABLE_DOMAIN_OBJECT',
  MUTABLE_DOMAIN_OBJECT: 'MUTABLE_DOMAIN_OBJECT',
  PLATE_SCHEMA_INTERFACE: 'PLATE_SCHEMA_INTERFACE',
} as const;
